export interface ITemplateLanguageStatus {
  language: string;
  status?: string;
  validationMessage?: string;
}

export enum ITemplateLanguageStatusEnum {
  Draft = 'DRAFT',
  Live = 'LIVE',
}

export interface ITemplate {
  audit: {
    comment: string;
    createdAt: string;
    createdBy: string;
    lastUpdatedAt: string;
    lastUpdatedBy: string;
    s3VersionId: string;
  };
  channel: string;
  type: string;
  isEmbedded: boolean;
  id: string;
  siteId: string;
  template: string;
  templateName: string;
  enrichmentConfigIds: string[];
  supportedLanguages: ITemplateLanguageStatus[];
  isArchived?: boolean;
}

export interface ITemplateHistoryItem {
  versionId: string;
  comment: string;
  userId: string;
  email: string;
  name: string;
  date: number;
}
